import {GameModuleResponse} from './GameModuleResponse';
import {GameModules} from '../GameModules';
import {IPickRound} from '../Types/IPickRound';

/**
 * @class GameModulePickResponse - game module response type of module "pick", eq: ResponseBase->modules["pick"].
 */
export class GameModulePickResponse extends GameModuleResponse {
    /**
     * Pick round ID.
     */
    pickRoundId: number;

    /**
     * Total count of pick rounds.
     */
    totalRounds: number;

    /**
     * Sum of all cash wins during all pick rounds.
     */
    totalWin: number;

    /**
     * Total count of free spins won.
     */
    count: number;

    /**
     * Final multiplier for free spins won.
     */
    multiplier: number;

    /**
     * Information about current pick round.
     */
    round: IPickRound;

    protected internalValidate(errors: Array<string>): void {
        // TODO(psulek) add check of other required properties...
    }

    public moduleName(): string {
        return GameModules.Pick;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/GameModulePickResponse.ts
 **/